import React from "react";
import Angular from "assets/tecnologias/angular.svg";
import anvisa from "assets/tecnologias/anvisa.png";
import aws from "assets/tecnologias/aws.png";
import FHIR from "assets/tecnologias/fhir.png";
import Java from "assets/tecnologias/java.svg";
import javascript from "assets/tecnologias/javascript.svg";
import openEHR from "assets/tecnologias/openEHR.svg";
import ReactNative from "assets/tecnologias/react-native.png";
import tableau from "assets/tecnologias/tableau.png";
import TUSS from "assets/tecnologias/tuss.png";
import loinc from "assets/tecnologias/loinc.png";
import snomed from "assets/tecnologias/snomed.png";
import { Carousel } from "components/carousel/Carousel";
import { CarouselItemMultiple } from "components/carousel/ItemMultiple";

export const OperadorasCarouselTecnologias = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <h1 className="col text-center text-blue font-weight-bold py-5">
          Nossas tecnologias
        </h1>
      </div>
      <div className="row">
        <div className="col d-sm-none">
          <Carousel settings={{ autoplay: false, autoplaySpeed: 3000 }}>
            <CarouselItemMultiple
              parceiros={[
                [openEHR, FHIR],
                [TUSS, anvisa],
              ]}
            />
            <CarouselItemMultiple
              parceiros={[
                [loinc, snomed],
                [tableau, aws],
              ]}
            />
            <CarouselItemMultiple
              parceiros={[
                [Angular, ReactNative],
                [Java, javascript],
              ]}
            />
          </Carousel>
        </div>
        <div className="col d-none d-sm-block">
          <Carousel
            settings={{ autoplay: false, dots: false, autoplaySpeed: 3000 }}
          >
            <CarouselItemMultiple
              parceiros={[
                [TUSS, loinc, snomed],
                [openEHR, anvisa, FHIR],
                [Angular, ReactNative, Java],
                [javascript, aws, tableau],
              ]}
            />
          </Carousel>
        </div>
      </div>
    </div>
  );
};
